import Image from "@Components/Image";
import styles from "./StepCard.module.scss";
import config from "@Config/index";
import wrapperHOC from "@Utils/wrapperHOC";

const StepCard = ({ stepNumber, imgSrc, title, subTitle, showArrow }: any) => (
  <>
    <div className={styles.stepCardOuter}>
      <div className={styles.stepCardInner}>
        <div className={styles.stepNumber}>{stepNumber}</div>
        <Image src={imgSrc} height={38} width={46} alt={title} />
        <h4 className={styles.title}>{title}</h4>
        <div className={styles.subTitle}>{subTitle}</div>
      </div>
      {showArrow && (
        <Image
          src={`${config.IMAGE_STATIC_ASSETS_APP_PATH}/assets/step-arrow-right.svg`}
          height={6}
          width={25.2}
          className={styles.icon}
          alt=""
        />
      )}
    </div>
  </>
);

export default wrapperHOC(StepCard, {
  componentName: "StepCard-ThreeStepsSection-Referral",
  showForChina: true,
});
